"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReorderSportsResponseDto = instanceOfReorderSportsResponseDto;
exports.ReorderSportsResponseDtoFromJSON = ReorderSportsResponseDtoFromJSON;
exports.ReorderSportsResponseDtoFromJSONTyped = ReorderSportsResponseDtoFromJSONTyped;
exports.ReorderSportsResponseDtoToJSON = ReorderSportsResponseDtoToJSON;
exports.ReorderSportsResponseDtoToJSONTyped = ReorderSportsResponseDtoToJSONTyped;
/**
 * Check if a given object implements the ReorderSportsResponseDto interface.
 */
function instanceOfReorderSportsResponseDto(value) {
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    if (!('swapsRemaining' in value) || value['swapsRemaining'] === undefined)
        return false;
    if (!('swapsUsed' in value) || value['swapsUsed'] === undefined)
        return false;
    if (!('freeSwapUsed' in value) || value['freeSwapUsed'] === undefined)
        return false;
    if (!('annualSwapsRemaining' in value) || value['annualSwapsRemaining'] === undefined)
        return false;
    return true;
}
function ReorderSportsResponseDtoFromJSON(json) {
    return ReorderSportsResponseDtoFromJSONTyped(json, false);
}
function ReorderSportsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportCodes': json['sportCodes'],
        'swapsRemaining': json['swapsRemaining'],
        'swapsUsed': json['swapsUsed'],
        'freeSwapUsed': json['freeSwapUsed'],
        'annualSwapsRemaining': json['annualSwapsRemaining'],
        'swapsResetAt': json['swapsResetAt'] == null ? undefined : json['swapsResetAt'],
    };
}
function ReorderSportsResponseDtoToJSON(json) {
    return ReorderSportsResponseDtoToJSONTyped(json, false);
}
function ReorderSportsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportCodes': value['sportCodes'],
        'swapsRemaining': value['swapsRemaining'],
        'swapsUsed': value['swapsUsed'],
        'freeSwapUsed': value['freeSwapUsed'],
        'annualSwapsRemaining': value['annualSwapsRemaining'],
        'swapsResetAt': value['swapsResetAt'],
    };
}
